import React from "react";
//import ReactDOM from 'react-dom';
//import axios from 'axios';
import  './Products.css';
import AuthService from '../Services/auth.service';
import CartService from '../Services/cart.service';
//import {  InputGroup, Input, Button, InputGroupAddon } from "reactstrap";
//import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
//import RemoveOutlinedIcon from '@material-ui/icons/RemoveOutlined';
//import { AddAlert } from '@material-ui/icons';
//import ReactLoading from 'react-loading';
//import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import  './ProductListSlider.css';

class ProductsHome extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            showQty: undefined,
            disabled:'',
            selectedItem: this.props.data?this.props.data['item_code']:undefined,
            selectedQty: 1,
            selectedRate: this.props.data?this.props.data['price']:undefined,
            menu:[],
            stockStatus:false,
            btnTxt:'Add to cart',
        }
    }
    async componentDidMount(){
        this.getData()
        this.checkItem(this.props.data['item_code'])
    }
    async getData(){

        if(this.props.data['stock'] > 0){
            this.setState({stockStatus:true})
        }else{
            this.setState({btnTxt:'Out of Stock'})
        }


        let cart = AuthService.getCartitems()
  
        try{
            if(cart.length > 0){
                
                for (let itm in cart) {
       
                        if(cart[itm]['item_code']===this.props.data['name']){
                                this.setState({showQty:"yes"})
                                this.setState({selectedItem:cart[itm]['item_code']})
                                this.setState({selectedQty:cart[itm]['qty']})
                            // this.setState({disabled:"disabled"})
                           // alert(this.state.selectedQty)
                        }
                    
                } 
               
            }
        }
        catch(e){ }
    }
    componentDidUpdate(){
        
    }
    
    addQty = async e => {
        //alert("ok")
        e.preventDefault();
        let qty = this.state.selectedQty
        this.setState({ selectedQty: 'loading...' })
        await CartService.addQty(this.state.selectedItem, qty)
            .then(response=>{
                this.setState({ selectedQty: qty + 1 })
               // alert(qty)
            })
            .catch(response=>{
               console.log("error")
            })
        
    }
    subQty= async e => {
        e.preventDefault();
        
        if(this.state.selectedQty > 0){
            let qty = this.state.selectedQty
            this.setState({ selectedQty: 'loading...' })
              await CartService.subQty(this.state.selectedItem, this.state.selectedQty)
              .then(response=>{
                    this.setState({ selectedQty: qty + 1 })
                    this.setState({ selectedQty: (qty > 0 )?qty - 1 : qty })
                })
              
        }
       if(this.state.selectedQty <= 0){
       // this.setState({btnTxt:'Add to cart'})
        this.setState({showQty:false})
        this.setState({selectedQty:1})
        this.getData()
        CartService.update_cart_local()
        CartService.update_cart()
      } 
    }
    selectItem  = async e => {

        this.ItemCode = e.target.value
        this.setState({ selectedItem: e.target.value })
        this.setState({ selectedDesc: e.target[e.target.selectedIndex].getAttribute('data-desc') })
        this.setState({ selectedRate: e.target[e.target.selectedIndex].getAttribute('data-rate') })
        this.checkItem(this.ItemCode)
    
    }
    
    async checkItem(item_code){
        const USR_TOKEN = localStorage.getItem("userToken")
        if(USR_TOKEN){
          let cart = AuthService.getserverCartitems();
          console.log(cart)
            try{
                if(cart.length > 0){
                    this.setState({showQty:false})
                    for (let itm in cart) {
                            console.log(cart[itm]['qty'])
                            if(cart[itm]['item_code']===item_code){
                                  this.setState({showQty:true})
                                  this.setState({selectedItem:cart[itm]['item_code']})
                                  this.setState({selectedQty:cart[itm]['qty']})
                                // this.setState({disabled:"disabled"})
                            }
                            
                      
                    } 
                }
            }
            catch(e){  }
          
  
        }
        else{
            let cart = AuthService.getCartitems()
            try{
                if(cart.length > 0){
                   // alert(cart.length)
                   // console.log(cart)
                    this.setState({showQty:false})
                    for (let itm in cart) {
                            //console.log(cart[itm]['item_code'] + " - " + item_code)
                            if(cart[itm]['item_code']===item_code){
                                  this.setState({showQty:true})
                                  this.setState({selectedItem:cart[itm]['item_code']})
                                  this.setState({selectedQty:cart[itm]['qty']})
                                // this.setState({disabled:"disabled"})
                            }
                            
                      
                    } 
                }
                
            }
            catch(e){  }
        }
        
  
      }
    addToCart= async e => {
        console.log(this.props.data)
        e.preventDefault();       

        if (this.props.data.variants.length > 0) {
            window.location.href = "/product-details/"+this.state.selectedItem
        }
        else{

            if(this.state.stockStatus){
                const delay = ms => new Promise(res => setTimeout(res, ms));
                try {
                
                            this.setState({showQty:"yes"})
                            let itemData={
                                item_code:this.state.selectedItem, 
                                item_name:this.state.selectedDesc?this.props.data.item_name + ' - ' + this.state.selectedDesc : this.props.data.item_name,
                                image:this.props.data.image,
                                desc:'', 
                                qty: this.state.selectedQty, 
                                rate:this.state.selectedRate
                            }
                            await CartService.addToCart(itemData)
                            //await CartService.update_cart_local() 
                            //alert("vvv")
                            
                        await delay(1000);
                    
                }
                catch(err) {
                    console.log(err)
                    //  document.getElementById("options-selected").insertAdjacentHTML("beforeend","<div id='sdrop' ><strong>Drop</strong> : " + e.target.value + "</div>");                                 
                }
            }
        }
    }
    render() {
        return  <div className="slider-single-item p-2 pb-5" >
                    {/*  <!-- Single Item --> */}
                        <article className="product-boarder list-product p-0 text-center ">
                            <div className="product-inner ">
                                <div className="img-block">
                                {this.state.stockStatus ? "" : <span className="sold-out-overlay">Out of stock</span>}
                                    <a href={'/product-details/'+this.props.data.item_code} className="thumbnail">
                                        <img className="first-img img-balance" src={process.env.REACT_APP_API_URL + this.props.data.website_image} alt="" />
                                       {/*  <img className="second-img" src="assets/images/product-image/9.jpg" alt="" /> */}
                                    </a>
                                   {/*  <div className="add-to-link">
                                        <ul>
                                            <li>
                                                <a className="quick_view" href="#" data-link-action="quickview" title="Quick view" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                    <i className="lnr lnr-magnifier"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="wishlist.html" title="Add to Wishlist"><i className="lnr lnr-heart"></i></a>
                                            </li>
                                            <li>
                                                <a href="compare.html" title="Add to compare"><i className="lnr lnr-sync"></i></a>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                                {/* <ul className="product-flag">
                                    <li className="new">-12%</li>
                                </ul> */}
                                <div className="product-decs height-balance">
                                    <a className="inner-link" href={'/product-details/'+this.props.data.item_code}><span>{this.props.data.item_group}</span></a>
                                    <h2><a href={'/product-details/'+this.props.data.item_code} className="product-link rate-height">{this.props.data.item_name}</a></h2>
                                    <div className="pricing-meta">
                                        <ul>
                                            {/* <li className="old-price">$23.90</li> */}
                                            <li className="current-price rupay-font">₹ {this.props.data.price}</li>
                                        </ul>
                                    </div>
                                </div>


                                {/* <div className="cart-btn ofs-btn">
                                   <a href="/#" className={ this.state.stockStatus ? "add-to-curt" : "add-to-curt btn-secondary" } title="Add to cart" style={this.state.showQty ? { transform: 'scale(0)' } : { display: 'inline-block',transform: 'scale(1)' }} onClick={this.addToCart}>{this.state.btnTxt}</a>
                                </div>
                                <div className={this.state.showQty ? 'quantity-input counter-prdct ' : 'd-none '}>
                                    <button className="quantity-input__modifier quantity-input__modifier--left" onClick={this.subQty} addonType="prepend">
                                        &mdash;
                                    </button>
                                    <input className="quantity-input__screen" type="text" value={this.state.selectedQty} readonly />
                                    <button className="quantity-input__modifier quantity-input__modifier--right"  onClick={this.addQty} addonType="append">
                                       &#xff0b;
                                    </button>  
                                </div> */}
                                

                                
                            </div>
                        </article>
                        {/* <!-- Single Item --> */}
                    </div>               
}
}
export default ProductsHome;